import React from 'react';

import classes from './Icon.css';

const menuIcon = () => {

  return(
    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
    	 viewBox="0 0 489.944 489.944" xmlSpace="preserve" className={classes.MenuIcon}>
    	<g>
    		<g>
    			<g>
    				<path d="M413.435,68.899l-22.839-0.128c-0.015,0-0.029,0-0.044,0c-0.043,0-0.084,0.006-0.126,0.006v-15.19
    					c0-4.228-3.427-7.656-7.655-7.656h-22.966V30.622c0-4.228-3.427-7.655-7.655-7.655H161.57C160.596,10.14,149.856,0,136.785,0
    					C123.713,0,112.974,10.14,112,22.966H76.554c-4.228,0-7.655,3.427-7.655,7.655v390.426c0,4.228,3.427,7.655,7.655,7.655h15.31
    					v22.966c0,4.228,3.427,7.655,7.655,7.655h15.311v22.966c0,4.228,3.427,7.655,7.655,7.655h290.906
    					c4.228,0,7.655-3.427,7.655-7.655V76.554C421.048,72.343,417.647,68.922,413.435,68.899z M136.785,15.311
    					c4.618,0,8.48,3.294,9.363,7.655h-18.726C128.304,18.605,132.166,15.311,136.785,15.311z M84.21,413.392V38.277h27.711V93.7
    					c0,13.711,11.154,24.865,24.864,24.865c13.711,0,24.864-11.155,24.864-24.865V59.282c0-4.228-3.427-7.655-7.656-7.655
    					c-4.228,0-7.655,3.427-7.655,7.655V93.7c0,5.268-4.286,9.554-9.554,9.554s-9.553-4.286-9.553-9.554V38.277h217.261v375.115H84.21
    					z M107.174,444.014v-15.311h0.001h244.973c4.228,0,7.655-3.427,7.655-7.655V61.243h15.311v382.771H107.174z M130.142,474.636
    					v-15.311H382.77c4.228,0,7.655-3.427,7.655-7.655V84.078c0.029,0.001,0.056,0.005,0.085,0.005l15.226,0.085v390.468H130.142z"/>
    				<path d="M267.94,168.419H160.762c-4.228,0-7.656,3.427-7.656,7.656c0.001,4.227,3.428,7.655,7.656,7.655H267.94
    					c4.228,0,7.655-3.427,7.655-7.655C275.595,171.847,272.168,168.419,267.94,168.419z"/>
    				<path d="M267.94,199.041H160.762c-4.228,0-7.656,3.427-7.656,7.656c0.001,4.227,3.428,7.655,7.656,7.655H267.94
    					c4.228,0,7.655-3.427,7.655-7.655C275.595,202.469,272.168,199.041,267.94,199.041z"/>
    				<path d="M237.317,229.662h-45.933c-4.228,0-7.655,3.427-7.655,7.656c0,4.228,3.427,7.655,7.655,7.655h45.933
    					c4.228,0,7.655-3.427,7.655-7.655S241.546,229.662,237.317,229.662z"/>
    			</g>
    		</g>
    	</g>
    </svg>
  );
};

export default menuIcon;



// WEBPACK FOOTER //
// ./src/components/Icon/MenuIcon.js